/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCheckIcon16Solid = forwardRef('FolderCheckIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.5A1.5 1.5 0 0 1 2.5 2h3.3a1.5 1.5 0 0 1 1.205.607L8.037 4H12.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-8Zm10.466 4.104a.8.8 0 1 0-1.132-1.131l-3.3 3.3-1.368-1.367a.8.8 0 1 0-1.132 1.131l1.58 1.58a1.3 1.3 0 0 0 1.839 0l3.513-3.513Z" })));
});
